"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MutationsQueue = void 0;
const GraphQLMutationsQueue = __importStar(require("@genesys/graphql-mutations-queue"));
const React = __importStar(require("react"));
const uuid_1 = require("uuid");
const Contexts = __importStar(require("../contexts"));
class MutationsQueue extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            queueId: this.props.persistentQueueId || (0, uuid_1.v4)()
        };
    }
    render() {
        return (React.createElement(Contexts.mutationsQueueContext.Consumer, null, ({ mutationQueues, queue, deQueue, discardQueue, flushQueue, applyPatches }) => {
            const mutationQueue = mutationQueues[this.state.queueId] ||
                GraphQLMutationsQueue.EmptyQueue;
            return React.Children.only(this.props.children({
                hasNonFlushedChanges: mutationQueue.queuedMutations.length > 0,
                mutationQueue,
                queue: (queueMutationDescription) => {
                    queue(this.state.queueId, [queueMutationDescription]);
                },
                deQueue: (queuedMutations) => {
                    deQueue(this.state.queueId, queuedMutations);
                },
                discardQueue: () => {
                    discardQueue(this.state.queueId);
                },
                applyPatches,
                flushQueue: async () => {
                    return await flushQueue(this.state.queueId);
                },
                queueAndFlush: async (queueMutationDescriptions) => {
                    queue(this.state.queueId, queueMutationDescriptions);
                    return new Promise((resolve) => {
                        //Important to do this in next tic so react can rerender and give new mutations state to provider
                        setImmediate(async () => {
                            const results = await flushQueue(this.state.queueId);
                            resolve(results);
                        });
                    });
                }
            }));
        }));
    }
}
exports.MutationsQueue = MutationsQueue;
//# sourceMappingURL=mutations-queue.js.map